import { clearCookies } from "../utils/cookies"

const DEFAULT_IDLE_TIME = 15

const ClearandRefresh = (idleTimeoutSeconds = DEFAULT_IDLE_TIME) => {
  const timeout = Number.isSafeInteger(idleTimeoutSeconds) && idleTimeoutSeconds > 0
    ? idleTimeoutSeconds
    : DEFAULT_IDLE_TIME
  let lastActivityAt = Date.now()

  const logout = () => {
    console.log("Idle timeout - logging out")
    clearCookies()
    sessionStorage.clear()
    window.location.replace("about:blank")
  }

  const timer = setInterval(() => {
    const elapsedSeconds = Math.floor((Date.now() - lastActivityAt) / 1000)
    if (elapsedSeconds >= timeout) {
      clearInterval(timer)
      logout()
    }
  }, 1000)

  const resetIdleTimer = () => {
    lastActivityAt = Date.now()
  }

  const events = ["mousemove", "keypress", "click", "scroll", "touchstart"]
  events.forEach((event) => window.addEventListener(event, resetIdleTimer))

  return () => {
    clearInterval(timer)
    events.forEach((event) => window.removeEventListener(event, resetIdleTimer))
  }
}

export { ClearandRefresh }
